import React, { useState, useEffect } from 'react'

import Grid from '@mui/material/Grid';

import AssetsFilterCriteria from './AssetsFilterCriteria'
import AssetsListImpl from './AssetsListImpl'
import MyPageContainer from '../../core/template/MyPageContainer';
import {getListAPI} from './AssetsAPI';
import {transformToCardFormat} from '../../core/js/FormUtils'
import {getPathVariable} from '../../core/js/UrlUtils';

import { useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import {setAssetsDashboardAssetsList } from '../../store/slice/ManufSlice';

export default function AssetsListView({setShowEdit,setAssetsId}){
    const {filterCriteria} = useSelector((state)=>state.manufslice.assetsDashboard);   

    const [filteredAssetsList, setFilteredAssetsList] = React.useState([]);
    const [cardList, setCardList] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const { showfilter } = useSelector((state) => state.confslice);
    const { assetsDashboard } = useSelector((state) => state.manufslice);
    
    function dataFetchCallBack(){
    }

    useEffect(()=>{
      if (assetsDashboard.assetsList.length>-1){
        setFilteredAssetsList(assetsDashboard.assetsList);
        transformToCardFormat(assetsDashboard.assetsList, setCardList);
      }
    },[assetsDashboard.assetsList])

    useEffect(()=>{
          transformToCardFormat(filteredAssetsList, setCardList);
      },[filteredAssetsList])

    useEffect(()=>{
        if (filterCriteria.title==='' && filterCriteria.path==='' && filterCriteria.assettype==='' && filterCriteria.productid==='' && filterCriteria.damassetid==='' ){
            setFilteredAssetsList(assetsDashboard.assetsList);
            transformToCardFormat(assetsDashboard.assetsList, setCardList);

        } else {
            setFilteredAssetsList(
                assetsDashboard.assetsList
                    .filter(assets=> assets.title.toString().toUpperCase().includes(filterCriteria.title.toString().toUpperCase()))

                
            )
            

            //transformToCardFormat(assetsDashboard.filteredAssetsList, setCardList);
        }
      },[filterCriteria])
  
     return(
        <Grid container direction="column" >
            <Grid item lg={12}>
                <AssetsListImpl
                    setShowEdit={setShowEdit}
                    setAssetsId = {setAssetsId}
                    tableList={filteredAssetsList}
                    cardList={cardList}
                    />
          </Grid>
      </Grid>
    )
}